import React from 'react';

const PageTitle = ({ title, subtitle }) => {
  return (
    <div className="relative py-4 mb-4">
      {/* Decorative background element */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-32 h-1 bg-blue-100 rounded-full"></div>
      </div>
      
      {/* Main title */}
      <h1 className="relative text-3xl font-bold text-gray-800 text-center mb-2">
        {title}
      </h1>
      
      {/* Optional subtitle */}
      {subtitle && (
        <p className="text-gray-600 text-center text-lg">
          {subtitle}
        </p>
      )}
      
      {/* Bottom decorative elements */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex items-center space-x-2">
        <div className="w-2 h-2 bg-blue-200 rounded-full"></div>
        <div className="w-2 h-2 bg-blue-300 rounded-full"></div>
        <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
      </div>
    </div>
  );
};

export default PageTitle;